const queryStringToStringArrayFromSelection = (q: string, selection): string[] => {
  const qSplit = q.split(',')

  return selection.filter(s => qSplit.includes(s)) ?? []
}

export { queryStringToStringArrayFromSelection }
